<template>
  <el-dialog
    top="15vh"
    class="product-edit__dialog"
    :title="json.name ? $t('Common.edit') : $t('Common.create')"
    width="900px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
    append-to-body
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="110px"
      size="small"
      label-suffix=": "
    >
      <el-form-item prop="name">
        <template slot="label">
          <el-tooltip class="item" effect="dark" placement="right-start" :visible-arrow="false">
            <span>
              {{ $t('Product.paramName') }}
              <svg class="icon">
                <use xlink:href="#icon-question1"></use></svg
            ></span>
            <template slot="content">
              {{ $t('Product.tips8') }} <br />
              {{ $t('Product.tips9') }} <br />
              {{ $t('Product.tips10') }}
            </template>
          </el-tooltip>
        </template>
        <el-input v-model="form.name" :placeholder="$t('Common.maxLengthTips16')" :maxlength="16">
        </el-input>
      </el-form-item>
      <el-form-item prop="identifier">
        <template slot="label">
          <el-tooltip class="item" effect="dark" placement="right-start" :visible-arrow="false">
            <span>
              {{ $t('Product.identifier') }}
              <svg class="icon">
                <use xlink:href="#icon-question1"></use></svg
            ></span>
            <template slot="content">
              {{ $t('Product.tips11') }} <br />
              {{ $t('Common.maxLengthTips16') }}
            </template>
          </el-tooltip>
        </template>
        <el-input
          v-model="form.identifier"
          :placeholder="$t('Common.maxLengthTips16')"
          :maxlength="16"
        >
        </el-input>
      </el-form-item>
      <DataTypeFormItem v-model="form" :needComplexDatatype="needComplexDatatype" />
    </el-form>
    <div slot="footer" class="edit-footer">
      <hl-button type="border" @click="close">{{ $t('Common.cancel') }}</hl-button>
      <hl-button @click="save" :loading="loading">{{ $t('Common.save') }}</hl-button>
    </div>
  </el-dialog>
</template>

<script>
import { dataTypeOptions } from './data'
export default {
  model: {
    prop: 'json',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    json: {
      type: Object
    },
    needComplexDatatype: {
      type: Boolean,
      default: true
    }
  },
  components: {
    DataTypeFormItem: () => import('./DataTypeFormItem')
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (!/^[a-zA-Z0-9\u4e00-\u9fa5]+[\u4e00-\u9fa5\w-\\.]*$/.test(value)) {
        callback(new Error(`${this.$t('Product.tips12')}`))
      } else {
        callback()
      }
    }
    const validateIdentifier = (rule, value, callback) => {
      if (!/^\w+$/.test(value)) {
        callback(new Error(`${this.$t('Product.tips13')}`))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      dataTypeOptions,
      form: {
        dataType: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('Product.paramName'), trigger: 'blur' },
          { validator: validateName, trigger: 'blur' }
        ],
        identifier: [
          { required: true, message: this.$t('Product.identifier'), trigger: 'blur' },
          { validator: validateIdentifier, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    const specs = this.json.specs
    let enumDescArr = []
    let enumDesc = {}
    if (specs.enumDesc && Object.keys(specs.enumDesc).length > 0) {
      enumDesc = specs.enumDesc
      for (const key in specs.enumDesc) {
        enumDescArr.push({
          key,
          value: specs.enumDesc[key]
        })
      }
    } else {
      enumDesc = { 0: '', 1: '' }
      enumDescArr.push({ key: undefined, value: '' })
    }
    this.form = {
      ...this.form,
      ...this.json,
      specs: {
        item: [],
        enumDesc,
        enumDescArr,
        ...specs
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (!this.checkForm()) return
      const {
        dataType,
        specs: { enumDescArr }
      } = this.form
      if (dataType === 'enum' && enumDescArr) {
        const enumDesc = {}
        this.form.specs.enumDescArr.forEach((item) => {
          enumDesc[item.key] = item.value
        })
        this.form.specs.enumDesc = enumDesc
        // this.form.specs.enumDescArr = undefined
      }
      this.$emit('save', this.form)
    }
  }
}
</script>
<style lang="scss" scoped></style>
